import { API_BASE_URL } from './baseUrl';

export interface AnalysisResult {
  matchScore: number;
  highlightedStrengths: string[];
  missingRequirements: string[];
  changesMade: string[];
  warnings: string[];
  optimizedCV: string;
  originalFileName: string;
}

export interface AnalysisResponse {
  success: boolean;
  data: AnalysisResult;
  error?: string;
}

/**
 * Analyze CV against job posting
 */
export async function analyzeCV(cvFile: File, jobPosting: string, customPrompt: string): Promise<AnalysisResult> {
  const formData = new FormData();
  formData.append('cv', cvFile);
  formData.append('jobPosting', jobPosting);
  formData.append('customPrompt', customPrompt);

  const token = localStorage.getItem('authToken');
  const headers: any = {};
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}/analysis/analyze`, {
    method: 'POST',
    headers,
    body: formData
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Błąd podczas analizy CV');
  }

  const result: AnalysisResponse = await response.json();
  return result.data;
}

/**
 * Check if backend is ready
 */
export async function checkBackendStatus(): Promise<{ ready: boolean; message: string }> {
  try {
    const response = await fetch(`${API_BASE_URL}/analysis/status`);
    return await response.json();
  } catch (error) {
    return {
      ready: false,
      message: 'Backend niedostępny'
    };
  }
}
